/* eslint-disable */
/* eslint-disable react/prop-types */
/* eslint-disable quotes */
import React from 'react';

import { useMemo, useState, useEffect } from 'react';
import { useSelector} from "react-redux";
//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_GlobalFilterTextField,
  MRT_ToggleFiltersButton,
} from 'material-react-table';

//Material UI Imports
import {
  Box,
  Button,
  Dialog,
  ListItemIcon,
  MenuItem,
  Typography,
  lighten,
  Avatar,
  IconButton,
  Switch,
  FormControlLabel,
  Tabs,
  Tab,
} from '@mui/material';

//Icons Imports
import { Add, Edit, Delete, PersonAdd, CloudUpload, Delete as DeleteIcon, Person } from '@mui/icons-material';

import FormComponent from '../MaterialReactTableModals/FormComponent';
import AgentFormComponent from '../CustomTable/CustomFormComponent';

// new: standalone form for edit / publish workflows
import IndependantForm from './IndependantForm';

const Material_React_Table = ({
  data = [],
  columns = [],
  onRowAdd,
  onRowUpdate,
  onRowDelete,
  onAgentAdd,
  userInitialState,
  PublishtoPP,
  PublishToWebsite,
  officeData,
  handleApproveBroker,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isAgentModalOpen, setAgentModalOpen] = useState(false);
  const [modalType, setModalType] = useState(""); // 'add' or 'edit'
  const [selectedRow, setSelectedRow] = useState(null);

  // keep existing agent modal state (the original add-broker form)
  const [agentSourceRow, setAgentSourceRow] = useState(null);

  // new: modal state for the IndependantForm used for edit/publish actions
  const [isIndependantOpen, setIndependantOpen] = useState(false);
  const [independantSourceRow, setIndependantSourceRow] = useState(null);
  const [independantPublishMode, setIndependantPublishMode] = useState('none'); // 'none' | 'pp' | 'website'

  const branchData = useSelector((state) => state.branchData.branches)
  const auth = useSelector((state) => state.auth);

  const handleOpenModal = (type, rowData = null) => {
    setModalType(type);
    setSelectedRow(rowData);
    setModalOpen(true);
  };

  // original add-broker modal (keeps the old important form)
  const handleOpenAgentModal = (rowData = null) => {
    setAgentSourceRow(rowData);
    setAgentModalOpen(true);
  };

  const handleOpenIndependantModal = (rowData = null, publishMode = 'none') => {
    setIndependantSourceRow(rowData);
    setIndependantPublishMode(publishMode);
    setIndependantOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };

  const handleCloseAgentModal = () => {
    setAgentModalOpen(false);
    setAgentSourceRow(null);
  };

  const handleCloseIndependant = () => {
    setIndependantOpen(false);
    setIndependantSourceRow(null);
    setIndependantPublishMode('none');
  };

  const handleFormSubmit = (values) => {
    if (modalType === "add") {
      onRowAdd(values);
    } else if (modalType === "edit") {
      onRowUpdate(values);
    }
    handleCloseModal();
  };

  const handleAgentFormSubmit = (values) => {
    if (agentSourceRow) {
      if (onRowUpdate) onRowUpdate(values, agentSourceRow);
    } else {
      if (onAgentAdd) onAgentAdd(values);
    }
    handleCloseAgentModal();
  };

  const handleIndependantSubmit = (values) => {
    // When IndependantForm submits, bubble up as an agent add/update
    if (onAgentAdd) onAgentAdd(values);
    handleCloseIndependant();
  };

  const table = useMaterialReactTable({
    columns: useMemo(() => columns, [columns]),
    data: useMemo(() => data, [data]),
    enableColumnFilterModes: false,

  
    muiTableBodyCellProps: {
      sx: {
        textAlign: 'center',
        verticalAlign: 'middle', // keeps text vertically centered too
      },
    },


    enableColumnOrdering: true,
    enableGrouping: true,
    enableEditing: false,
    editingMode: 'row',
    enableColumnPinning: true,
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: true,
    initialState: {
      ...{
        showColumnFilters: false,
        showGlobalFilter: true,
        columnPinning: {
          left: ['mrt-row-expand', 'mrt-row-select'],
          right: ['mrt-row-actions'],
        },
      },
      ...userInitialState,
    },
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
    },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [10, 20, 30],
      shape: 'rounded',
      variant: 'outlined',
    },
    renderRowActionMenuItems: ({ row, closeMenu }) => [
      <MenuItem
        key="update-broker"
        onClick={() => {
          closeMenu();
          // open AgentFormComponent with row.original data
          handleOpenAgentModal(row.original);
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <Person />
        </ListItemIcon>
        Update Broker
      </MenuItem>,


      <>
        {!row.original?.agentId && (<MenuItem
          key="publish-pp"
          onClick={() => {
            closeMenu();
            // open IndependantForm preselected to publish to PP
            handleOpenIndependantModal(row.original, 'pp');
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Person />
          </ListItemIcon>
          Add to Property 24
        </MenuItem>)}
      </>,
      <>
        {
          !row.original?.websiteID && (<MenuItem
            key="publish-web"
            onClick={() => {
              closeMenu();
              // open IndependantForm preselected to publish to Website
              handleOpenIndependantModal(row.original, 'website');
            }}
            sx={{ m: 0 }}
          >
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            Add to Website
          </MenuItem>)
        }</>,
        <>
        {
          row.original?.approved !== true ? (<MenuItem
            key="broker-approved"
            onClick={() => {
              closeMenu();
              handleApproveBroker(row.original)
            }}
            sx={{ m: 0 }}
          >
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            Approve
          </MenuItem>) : (
            <MenuItem
            key="broker-approved"
            onClick={() => {
              closeMenu();
              handleApproveBroker(row.original)
            }}
            sx={{ m: 0 }}
          >
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            Unapprove
          </MenuItem>
          )
        }</>
        


      // keep any other menu items you want here (delete, add, etc.)
    ],
    renderTopToolbar: ({ table }) => {
      return (
        <Box
          sx={(theme) => ({
            backgroundColor: lighten(theme.palette.background.default, 0.05),
            display: 'flex',
            gap: '0.5rem',
            p: '8px',
            justifyContent: 'space-between',
          })}
        >
          <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <MRT_GlobalFilterTextField table={table} />
            <MRT_ToggleFiltersButton table={table} />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', gap: '0.5rem' }}>
              {/* original Add Broker button still opens your original AgentFormComponent */}
              <Button
                color="success"
                onClick={() => handleOpenAgentModal()}
                variant="contained"
                startIcon={<PersonAdd />}
              >
                Add Broker
              </Button>
            </Box>
          </Box>
        </Box>
      );
    },
  });

  return (
    <>
      <MaterialReactTable table={table} />

      {/* Add/Edit User Modal */}
      <Dialog open={isModalOpen} onClose={handleCloseModal} fullWidth maxWidth="md">
        {isModalOpen && (
          <FormComponent
            modalType={modalType}
            onClose={handleCloseModal}
            onSubmit={handleFormSubmit}
            data={selectedRow}
            columns={columns}
          />
        )}
      </Dialog>

      {/* ORIGINAL Add Broker Modal (important) */}
      <Dialog open={isAgentModalOpen} onClose={handleCloseAgentModal} fullWidth maxWidth="lg">
        {isAgentModalOpen && (
          <AgentFormComponent
            onClose={handleCloseAgentModal}
            onSubmit={handleAgentFormSubmit}
            sourceData={agentSourceRow}
            officeData={officeData}
          />
        )}
      </Dialog>

      {/* IndependantForm Modal (used for edit / publish actions) */}
      <Dialog open={isIndependantOpen} onClose={handleCloseIndependant} fullWidth maxWidth="lg">
        {isIndependantOpen && (
          <IndependantForm
            onClose={handleCloseIndependant}
            onSubmit={handleIndependantSubmit}
            sourceData={independantSourceRow}
            initialPublishMode={independantPublishMode}
            onPublishToPP={(row) => PublishtoPP && PublishtoPP(row)}
            onPublishToWebsite={(row) => PublishToWebsite && PublishToWebsite(row)}
          />
        )}
      </Dialog>
    </>
  );
};

export default Material_React_Table;
